import { render } from "./HsBadge.vue?vue&type=template&id=1b718894&scoped=true"
import script from "./HsBadge.vue?vue&type=script&lang=js"
export * from "./HsBadge.vue?vue&type=script&lang=js"

import "./HsBadge.vue?vue&type=style&index=0&id=1b718894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b718894"]])

export default __exports__